var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"download",style:({ opacity: _vm.opacity }),on:{"click":_vm.downloadFile}},[_c('img',{attrs:{"src":require("../../assets/download.svg"),"alt":""}}),_c('p',[_vm._v("DOWNLOAD FILE")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }